export default __webpack_public_path__ + "files/media/md.e37abdcd.jpg";